import { BaseRoutingFunction, ResourceRoutingFunction } from '@legacy/types/Routes'

export const QUOTE_PARAMETERS_PATH = '/parameters'
export const QUOTE_DETAILS_PATH = '/quote-details'
export const BIND_AND_PAY_PATH = '/bind-and-pay'

export const home: BaseRoutingFunction = () => '/'
export const contact: BaseRoutingFunction = () => '/contact'
export const howToClaim: BaseRoutingFunction = () => '/how_to_claim'
export const policyWordingDocuments: BaseRoutingFunction = () => '/policy_wording_documents'
export const plans: BaseRoutingFunction = () => '/plans'
export const partners: BaseRoutingFunction = () => '/partners'
export const quoteParameters: ResourceRoutingFunction = (id) =>
  id ? `${QUOTE_PARAMETERS_PATH}/${id}` : `${QUOTE_PARAMETERS_PATH}/:id`
export const quoteDetails: ResourceRoutingFunction = (id) =>
  id ? `${QUOTE_DETAILS_PATH}/${id}` : `${QUOTE_DETAILS_PATH}/:id`
export const bindAndPay: ResourceRoutingFunction = (id) =>
  id ? `${BIND_AND_PAY_PATH}/${id}` : `${BIND_AND_PAY_PATH}/:id`
export const policyCreated: BaseRoutingFunction = () => '/policy'
export const proposalCreated: BaseRoutingFunction = () => '/proposal_success'
export const authorizationSubmitted: BaseRoutingFunction = () => '/authorization_submitted'
export const notifiedPartnerQuoteReady: BaseRoutingFunction = () => '/notified_partner_quote_ready'
